//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {
    
    //Use strict mode
    'use strict';

    /**
     * @class am.AdditionalLayerController
     * @fires AdditionalLayerController
     *
     * This class implements the controller of the base layer selector.
     */
    module.AdditionalLayerController = function() {
        // Private attributes
        this._map  = undefined;                // reference to the map
        this._vectorLayer = undefined;         // reference to the Leaflet layer containing the geometry of the roofs / buildings
        this._rasterLayer = undefined;         // reference to the Leaflet layer containing the irradiation of each roof pixel
        this._visibilityButton = undefined;    // reference to the button allowing the user to show/hide the layers
        this._layerSelectorButton = undefined; // reference to the button allowing the user to choose the layer to be displayed
        this._config = {
            vectorTileFolder: undefined, // reference to the Leaflet layer to add
            vectorTileOptions: {
                rendererFactory: L.canvas.tile,
                interactive: false,
                vectorTileLayerStyles: {
                    potentiel_vegetalisation: function(properties, zoom) {
                        var potentiel = properties.Pot_Veg;
                        var style = {
                            stroke: zoom >= 18,
                            weight: 2,         // stroke width
                            opacity: 0.8,      // stroke alpha
                            lineJoin: 'round',
                            dashArray: null,
                            dashOffset: null,
                            fill: true,
                            fillOpacity: 0.6   // fill alpha
                        };
                        if (potentiel == 1) {
                            style.color = "red";
                        } else if (potentiel == 2) {
                            style.color = "orange";
                        } else {
                            style.color = "green";
                        }
                        return style;
                    }
                }
            },
            rasterTileFolder: undefined,
            rasterTileOptions: {
                tms: true,
                opacity: 0.5
            },
            addVisibilityButton: true
        };
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Object specifying the configuration to be applied to the controller. The same arguments
     *		which can be passed to the constructor of class L.Control can also be specified here
     *      (see http://leafletjs.com/reference-1.2.0.html#control). In addition, this object may contain the following
     *		keys:
     *			- "layers": Array specifying the base layers to be proposed to the user in the drop-down menu.
     *				Each element of this array should be an object with the following two keys:
     *					- "name": Name of the layer (e.g. 'IgnAerial', 'OpenStreetMaps', 'BingAerial', etc.)
     *					- "apiKey": [optional] API key to access the layer tiles
     *			  By default, the IGN aerial maps and the Open Street maps are proposed to the user
     */
    module.AdditionalLayerController.prototype.init = function(mainController, config) {
        // Instantiate the private attributes
       this._config = am.utils.mergeObjects(this._config, config);
        this._map = mainController.getMapObject();
        if (this._config.rasterTileFolder) {
            this._rasterLayer = this._createRasterLayer(mainController.getConfig()).addTo(this._map);
            $(this._rasterLayer.getContainer()).addClass('am-additional-layer-raster hidden');
        }
        if (this._config.vectorTileFolder) {
            this._vectorLayer = this._createVectorLayer(mainController.getConfig()).addTo(this._map);
            $(this._vectorLayer.getContainer()).addClass('am-additional-layer-vector hidden');
        }
        if (this._config.addVisibilityButton) {
            this._visibilityButton = this._createVisibilityButton(mainController.getConfig()).addTo(this._map);
        }
        this._layerSelectorButton = this._createLayerSelectorButton(mainController.getConfig()).addTo(this._map);
        var $buttonContainer = $(this._layerSelectorButton.getContainer());
        var $button = $buttonContainer.find('.btn');
        $buttonContainer.addClass('am-layer-selector-widget');
        $button.tooltip({
            trigger: 'manual',
            placement: 'right',
            animate: true,
            container: 'body',
            title: am.translator.translate("vegetationPotentialLayer")
        });
        setTimeout(function() {
            if (!$buttonContainer.hasClass('hidden')) {
                $button.tooltip('show');
                setTimeout(function () {
                    $button.tooltip('hide');
                    $button.tooltip('dispose');
                }, 5000);
            }
        }, 5000);

        // Register event handlers associated with the panel
        am.eventManager.register('hide_roof_layer', this._hideControlButtons, this);
        am.eventManager.register('show_roof_layer', this._showControlButtons, this);
    };

    /**
     * Class destructor
     */
    module.AdditionalLayerController.prototype.destroy = function() {
        // Remove control buttons from the map and remove references to external objects
        am.eventManager.unregister('hide_roof_layer', this._hideControlButtons, this);
        am.eventManager.unregister('show_roof_layer', this._showControlButtons, this);

        this._layerSelectorButton.remove();
        if (this._rasterLayer) {
            this._rasterLayer.remove();
        }
        if (this._vectorLayer) {
            this._vectorLayer.remove();
        }
        if (this._visibilityButton) {
            this._visibilityButton.remove();
        }

        this._map = undefined;
    };

    module.AdditionalLayerController.prototype._createRasterLayer = function(config) {
        // Check input folder
        var tileFolder = this._config.rasterTileFolder;
        if (tileFolder.charAt(tileFolder.length - 1) !== '/') {
            tileFolder += '/';
        }

        // Create view
        return L.tileLayer(tileFolder + '{z}/{x}/{y}.png', this._config.rasterTileOptions);
    };

    module.AdditionalLayerController.prototype._createVectorLayer = function(config) {
        // Check input folder
        var tileFolder = this._config.vectorTileFolder;
        if (tileFolder.charAt(tileFolder.length - 1) != '/') {
            tileFolder += '/';
        }

        // Create view
        return L.vectorGrid.protobuf(tileFolder + '{z}/{x}/{y}.pbf', this._config.vectorTileOptions);
    };

    module.AdditionalLayerController.prototype._createVisibilityButton = function(config) {
        var _this = this;
        return am.utils.twoStateButton({
            cssClass: "am-layer-visibility-button am-widget-frame",
            activeStateContentsClass: 'am-icon am-eye-crossed-icon',
            inactiveStateContentsClass: 'am-icon am-eye-icon',
            activeStateTooltip: am.translator.translate('hideLayers'),
            inactiveStateTooltip: am.translator.translate('showLayers'),
            activeStateCallback: function() {
                $('.am-roof-layer-raster').addClass('hidden');
                $('.am-roof-layer-vector').addClass('hidden');
                $('.am-additional-layer-raster').addClass('hidden');
                $('.am-additional-layer-vector').addClass('hidden');
                $('.am-layer-selector-widget').addClass('hidden');
            },
            inactiveStateCallback: function () {
                $('.am-layer-selector-widget').removeClass('hidden');
                if (_this._layerSelectorButton.isActive()) {
                    $('.am-roof-layer-raster').removeClass('hidden');
                    $('.am-roof-layer-vector').removeClass('hidden');
                } else {
                    $('.am-additional-layer-raster').removeClass('hidden');
                    $('.am-additional-layer-vector').removeClass('hidden');
                }
            }
        });
    };

    module.AdditionalLayerController.prototype._createLayerSelectorButton = function(config) {
        // Create the button
        var button = am.utils.twoStateButton({
            cssClass: "am-layer-selector-button am-widget-frame am-widget-button",
            activeStateContentsClass: 'am-icon am-leaf-icon',
            inactiveStateContentsClass: 'am-icon am-sun-icon',
            activeStateTooltip: am.translator.translate('showVegetationLayer'),
            inactiveStateTooltip: am.translator.translate('showRoofLayer')
        });

        // Create the legend for the solar potential below the button
        var irradClasses = am.utils.getIrradClasses(config);
        if (irradClasses.length > 1) {
            // Create the legend contents
            var $solarLegend = $('<div class="am-solar-potential-legend am-widget-frame"></div>');
            $solarLegend.append('<div class="picto am-legend-left-end" data-toggle="tooltip" title="' +
                am.translator.translate('goodSolarPotential') + '"><i class="am-icon am-sun-icon bright am-sun-icon-bright am-icon-lgd"></i></div>');
            $solarLegend.append('<div class="picto am-legend-right-end"  data-toggle="tooltip" title="' +
                am.translator.translate('badSolarPotential') + '"><i class="am-icon am-sun-icon bright am-sun-icon-dim am-icon-lgd"></i></div>');

            // Color the legend's background
            var backgroundColor = 'linear-gradient(to top, ' + irradClasses[0].lowerLimitColor;
            var lowerRangeLimit = irradClasses[0].lowerLimit;
            var upperRangeLimit = irradClasses[irradClasses.length - 1].upperLimit;
            for (var iClass = 0, nClasses = irradClasses.length; iClass < nClasses; ++iClass) {
                var currIrradClass = irradClasses[iClass];
                var breakPoint = (currIrradClass.upperLimit - lowerRangeLimit) / (upperRangeLimit - lowerRangeLimit);
                backgroundColor += ', ' + currIrradClass.upperLimitColor + ' ' + Math.round(breakPoint * 100) + '%';
            }
            backgroundColor += ')';
            $solarLegend.css('background', backgroundColor);

            // Add the legend below the button
            button.addHtmlContentsNextToButton($solarLegend);
        }

        // Create the legend for the vegetation potential below the button
        var $grassLegend = $('<div class="am-vegetation-potential-legend am-widget-frame hidden"></div>');
        $grassLegend.append('<h1>' + am.translator.translate('vegetationPotential') + '</h1>');
        $grassLegend.append('<div class="am-vegetation-class good-potential">' + am.translator.translate('good') + '</div>');
        $grassLegend.append('<div class="am-vegetation-class medium-potential">' + am.translator.translate('medium') + '</div>');
        $grassLegend.append('<div class="am-vegetation-class bad-potential">' + am.translator.translate('bad') + '</div>');
        button.addHtmlContentsNextToButton($grassLegend);

        // Define the callbacks which will be executed when the user clicks on the button
        var _this = this;
        var activeStateCallback = function() {
            $('.am-roof-layer-raster').addClass('hidden');
            $('.am-roof-layer-vector').addClass('hidden');
            $('.am-solar-potential-legend').addClass('hidden');
            $('.am-additional-layer-raster').removeClass('hidden');
            $('.am-additional-layer-vector').removeClass('hidden');
            $('.am-vegetation-potential-legend').removeClass('hidden');
        };
        var inactiveStateCallback = function () {
            $('.am-roof-layer-raster').removeClass('hidden');
            $('.am-roof-layer-vector').removeClass('hidden');
            $('.am-solar-potential-legend').removeClass('hidden');
            $('.am-additional-layer-raster').addClass('hidden');
            $('.am-additional-layer-vector').addClass('hidden');
            $('.am-vegetation-potential-legend').addClass('hidden');
        };
        button.setClickCallbacks(activeStateCallback, inactiveStateCallback);

        return button;
    };

    module.AdditionalLayerController.prototype._hideControlButtons = function() {
        $(this._layerSelectorButton.getContainer()).addClass('hidden');
        if (this._visibilityButton) {
            $(this._visibilityButton.getContainer()).addClass('hidden');
        }
    };

    module.AdditionalLayerController.prototype._showControlButtons = function() {
        $(this._layerSelectorButton.getContainer()).removeClass('hidden');
        if (this._visibilityButton) {
            $(this._visibilityButton.getContainer()).removeClass('hidden');
        }
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Function returning a new instance of class am.AdditionalLayerController
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Configuration object to be passed to the constructor of class 
     *      am.AdditionalLayerController
     * @return {am.AdditionalLayerController} - New instance of class am.AdditionalLayerController
     */
    module.additionalLayerController = function(mainController, config) {
        var ctrl = new am.AdditionalLayerController();
        ctrl.init(mainController, config);
        return ctrl;
    };

    return module;

})(am.utils || {});